import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNumber = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.7129 6.99625C11.8013 6.95958 11.8983 6.93934 12 6.93934C12.1017 6.93934 12.1987 6.95958 12.2871 6.99625C12.3755 7.03285 12.4584 7.0871 12.5303 7.15901C12.6022 7.23092 12.6565 7.31379 12.6931 7.40225C12.7298 7.49068 12.75 7.58765 12.75 7.68934V15.25H14C14.4142 15.25 14.75 15.5858 14.75 16C14.75 16.4142 14.4142 16.75 14 16.75H10C9.58579 16.75 9.25 16.4142 9.25 16C9.25 15.5858 9.58579 15.25 10 15.25H11.25V9.5L10.25 10.5C9.95711 10.7929 9.48223 10.7929 9.18934 10.5C8.89645 10.2071 8.89645 9.73223 9.18934 9.43934L11.4697 7.15901C11.5416 7.0871 11.6245 7.03285 11.7129 6.99625Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.75 6.5C2.75 4.42893 4.42893 2.75 6.5 2.75H17.5C19.5711 2.75 21.25 4.42893 21.25 6.5V17.5C21.25 19.5711 19.5711 21.25 17.5 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V6.5ZM6.5 4.25C5.25736 4.25 4.25 5.25736 4.25 6.5V17.5C4.25 18.7426 5.25736 19.75 6.5 19.75H17.5C18.7426 19.75 19.75 18.7426 19.75 17.5V6.5C19.75 5.25736 18.7426 4.25 17.5 4.25H6.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconNumber as ReactComponent };
